import ReplaceCardScreen from 'features/cardManagement/screens/lostStolenReplaceCard/ReplaceCardScreen/ReplaceCardScreen';
import React from 'react';

export default function ReplaceCardPage() {
  return <ReplaceCardScreen />;
}
